"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Row = exports.Title = exports.BodyWrapper = exports.Footer = exports.ProfilePicture = exports.Head = exports.Root = exports.classes = void 0;
const Avatar_1 = __importDefault(require("@mui/material/Avatar"));
const styles_1 = require("@mui/material/styles");
const typography_1 = __importDefault(require("../typography"));
const PREFIX = "ProfileCard";
exports.classes = {
    rowIcon: `${PREFIX}-rowIcon`
};
exports.Root = (0, styles_1.styled)("div")(({ theme }) => ({
    display: "flex",
    backgroundColor: theme.colours.white,
    boxShadow: "0px 1px 5px 0px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 3px 1px -2px rgba(0, 0, 0, 0.12)",
    textAlign: "center",
    position: "relative",
    height: "100%",
    flexDirection: "column",
    alignItems: "center",
    wordBreak: "break-word",
    "&::before": {
        content: "''",
        position: "absolute",
        height: "calc(30px + 75px)",
        top: 0,
        right: 0,
        left: 0,
        backgroundColor: theme.colours.pearl,
        zIndex: 0
    }
}));
exports.Head = (0, styles_1.styled)("div")({
    width: "150px",
    height: "150px",
    display: "inline-block",
    overflow: "hidden",
    position: "relative",
    zIndex: 1,
    marginTop: "30px"
});
exports.ProfilePicture = (0, styles_1.styled)(Avatar_1.default)({
    width: "150px",
    height: "150px"
});
exports.Footer = (0, styles_1.styled)("div")(({ theme }) => ({
    textAlign: "left",
    backgroundColor: theme.colours.pearl,
    padding: "15px",
    fontSize: "1rem",
    flex: 1,
    width: "100%"
}));
exports.BodyWrapper = (0, styles_1.styled)("div")(({ theme }) => ({
    padding: "24px 30px",
    backgroundColor: theme.colours.white,
    textAlign: "center",
    color: theme.colours.charcoal,
    flex: 1,
    [theme.breakpoints.up(1024)]: {
        padding: "20px 30px"
    }
}));
exports.Title = (0, styles_1.styled)(typography_1.default)(({ theme }) => ({
    marginTop: "8px",
    color: theme.colours.slate
}));
exports.Row = (0, styles_1.styled)("span")(({ theme }) => ({
    padding: "15px",
    display: "flex",
    alignItems: "flex-start",
    fontFamily: "Effra Medium",
    [`.${exports.classes.rowIcon}`]: {
        color: theme.colours.slate,
        width: "24px",
        height: "24px",
        marginRight: "12px"
    }
}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic3R5bGVzLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL3Byb2ZpbGUtY2FyZC9zdHlsZXMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7O0FBQUEsa0VBQTBDO0FBQzFDLGlEQUE4QztBQUM5QywrREFBdUM7QUFFdkMsTUFBTSxNQUFNLEdBQUcsYUFBYSxDQUFDO0FBRWhCLFFBQUEsT0FBTyxHQUFHO0lBQ3JCLE9BQU8sRUFBRSxHQUFHLE1BQU0sVUFBVTtDQUM3QixDQUFDO0FBRVcsUUFBQSxJQUFJLEdBQUcsSUFBQSxlQUFNLEVBQUMsS0FBSyxDQUFDLENBQUMsQ0FBQyxFQUFFLEtBQUssRUFBRSxFQUFFLEVBQUUsQ0FBQyxDQUFDO0lBQ2hELE9BQU8sRUFBRSxNQUFNO0lBQ2YsZUFBZSxFQUFFLEtBQUssQ0FBQyxPQUFPLENBQUMsS0FBSztJQUNwQyxTQUFTLEVBQ1AsK0dBQStHO0lBQ2pILFNBQVMsRUFBRSxRQUFRO0lBQ25CLFFBQVEsRUFBRSxVQUFVO0lBQ3BCLE1BQU0sRUFBRSxNQUFNO0lBQ2QsYUFBYSxFQUFFLFFBQVE7SUFDdkIsVUFBVSxFQUFFLFFBQVE7SUFDcEIsU0FBUyxFQUFFLFlBQVk7SUFDdkIsV0FBVyxFQUFFO1FBQ1gsT0FBTyxFQUFFLElBQUk7UUFDYixRQUFRLEVBQUUsVUFBVTtRQUNwQixNQUFNLEVBQUUsbUJBQW1CO1FBQzNCLEdBQUcsRUFBRSxDQUFDO1FBQ04sS0FBSyxFQUFFLENBQUM7UUFDUixJQUFJLEVBQUUsQ0FBQztRQUNQLGVBQWUsRUFBRSxLQUFLLENBQUMsT0FBTyxDQUFDLEtBQUs7UUFDcEMsTUFBTSxFQUFFLENBQUM7S0FDVjtDQUNGLENBQUMsQ0FBQyxDQUFDO0FBRVMsUUFBQSxJQUFJLEdBQUcsSUFBQSxlQUFNLEVBQUMsS0FBSyxDQUFDLENBQUM7SUFDaEMsS0FBSyxFQUFFLE9BQU87SUFDZCxNQUFNLEVBQUUsT0FBTztJQUNmLE9BQU8sRUFBRSxjQUFjO0lBQ3ZCLFFBQVEsRUFBRSxRQUFRO0lBQ2xCLFFBQVEsRUFBRSxVQUFVO0lBQ3BCLE1BQU0sRUFBRSxDQUFDO0lBQ1QsU0FBUyxFQUFFLE1BQU07Q0FDbEIsQ0FBQyxDQUFDO0FBRVUsUUFBQSxjQUFjLEdBQUcsSUFBQSxlQUFNLEVBQUMsZ0JBQU0sQ0FBQyxDQUFDO0lBQzNDLEtBQUssRUFBRSxPQUFPO0lBQ2QsTUFBTSxFQUFFLE9BQU87Q0FDaEIsQ0FBQyxDQUFDO0FBRVUsUUFBQSxNQUFNLEdBQUcsSUFBQSxlQUFNLEVBQUMsS0FBSyxDQUFDLENBQUMsQ0FBQyxFQUFFLEtBQUssRUFBRSxFQUFFLEVBQUUsQ0FBQyxDQUFDO0lBQ2xELFNBQVMsRUFBRSxNQUFNO0lBQ2pCLGVBQWUsRUFBRSxLQUFLLENBQUMsT0FBTyxDQUFDLEtBQUs7SUFDcEMsT0FBTyxFQUFFLE1BQU07SUFDZixRQUFRLEVBQUUsTUFBTTtJQUNoQixJQUFJLEVBQUUsQ0FBQztJQUNQLEtBQUssRUFBRSxNQUFNO0NBQ2QsQ0FBQyxDQUFDLENBQUM7QUFFUyxRQUFBLFdBQVcsR0FBRyxJQUFBLGVBQU0sRUFBQyxLQUFLLENBQUMsQ0FBQyxDQUFDLEVBQUUsS0FBSyxFQUFFLEVBQUUsRUFBRSxDQUFDLENBQUM7SUFDdkQsT0FBTyxFQUFFLFdBQVc7SUFDcEIsZUFBZSxFQUFFLEtBQUssQ0FBQyxPQUFPLENBQUMsS0FBSztJQUNwQyxTQUFTLEVBQUUsUUFBUTtJQUNuQixLQUFLLEVBQUUsS0FBSyxDQUFDLE9BQU8sQ0FBQyxRQUFRO0lBQzdCLElBQUksRUFBRSxDQUFDO0lBQ1AsQ0FBQyxLQUFLLENBQUMsV0FBVyxDQUFDLEVBQUUsQ0FBQyxJQUFJLENBQUMsQ0FBQyxFQUFFO1FBQzVCLE9BQU8sRUFBRSxXQUFXO0tBQ3JCO0NBQ0YsQ0FBQyxDQUFDLENBQUM7QUFFUyxRQUFBLEtBQUssR0FBRyxJQUFBLGVBQU0sRUFBQyxvQkFBVSxDQUFDLENBQUMsQ0FBQyxFQUFFLEtBQUssRUFBRSxFQUFFLEVBQUUsQ0FBQyxDQUFDO0lBQ3RELFNBQVMsRUFBRSxLQUFLO0lBQ2hCLEtBQUssRUFBRSxLQUFLLENBQUMsT0FBTyxDQUFDLEtBQUs7Q0FDM0IsQ0FBQyxDQUFDLENBQUM7QUFFUyxRQUFBLEdBQUcsR0FBRyxJQUFBLGVBQU0sRUFBQyxNQUFNLENBQUMsQ0FBQyxDQUFDLEVBQUUsS0FBSyxFQUFFLEVBQUUsRUFBRSxDQUFDLENBQUM7SUFDaEQsT0FBTyxFQUFFLE1BQU07SUFDZixPQUFPLEVBQUUsTUFBTTtJQUNmLFVBQVUsRUFBRSxZQUFZO0lBQ3hCLFVBQVUsRUFBRSxjQUFjO0lBQzFCLENBQUMsSUFBSSxlQUFPLENBQUMsT0FBTyxFQUFFLENBQUMsRUFBRTtRQUN2QixLQUFLLEVBQUUsS0FBSyxDQUFDLE9BQU8sQ0FBQyxLQUFLO1FBQzFCLEtBQUssRUFBRSxNQUFNO1FBQ2IsTUFBTSxFQUFFLE1BQU07UUFDZCxXQUFXLEVBQUUsTUFBTTtLQUNwQjtDQUNGLENBQUMsQ0FBQyxDQUFDIn0=